export class PlayerPoint {
    id: number;
    time: number;
    labelText: string;
    color = '#ff0000';
    editable =  true;
}
